/* eslint-disable react/no-danger */
import dynamic from 'next/dynamic';
import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';
import { memo } from 'react';
import { GET_ABOUT_PAGE } from '@containers/About/slice';
import LoadingContainer from '@components/LoadingContainer';

const About = dynamic(() => import('@containers/About'), {
  loading: () => <LoadingContainer loading />,
});

function AboutContainer() {
  return (
    <>
      <About />
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps(
  store =>
    async ({ locale }) => {
      store.dispatch(GET_ABOUT_PAGE({ locale }));
      store.dispatch(END);
      await (store as SagaStore).sagaTask?.toPromise();
      return {
        props: {},
        revalidate: 20,
      };
    },
);

export default memo(AboutContainer);
